// WhatsApp profile the backend saves when someone messages us on WhatsApp
// (conversation.whatsappProfile, contact.whatsapp). Values come from the sender,
// so text is type-checked and links are only rendered when they are plain http(s).

export const cleanText = value => (typeof value === 'string' && value.trim() ? value.trim() : null);

export const safeHttpUrl = url => {
  const text = cleanText(url);
  return text && /^https?:\/\//i.test(text) ? text : null;
};

export const contactName = contactDetails => {
  const properties = contactDetails?.properties || {};
  return [cleanText(properties.name), cleanText(properties.surname)].filter(Boolean).join(' ') || null;
};

// Contact name first (what the operator saved), then the WhatsApp profile name.
export const conversationName = conversation =>
  contactName(conversation?.contactDetails) || cleanText(conversation?.whatsappProfile?.name);

// The ad shown in the chat panel: the latest one, else the first.
export const whatsappReferral = profile => profile?.lastReferral || profile?.firstReferral || null;

export const referralLabel = referral =>
  cleanText(referral?.headline) || cleanText(referral?.body) || cleanText(referral?.sourceId);

const sameReferral = (a, b) =>
  ['at', 'sourceId', 'sourceUrl', 'ctwaClid', 'headline'].every(key => (a?.[key] ?? null) === (b?.[key] ?? null));

// First and latest ad, the latest left out when it is the same ad message as the first.
export const distinctReferrals = profile => {
  const first = profile?.firstReferral;
  const last = profile?.lastReferral;
  return [
    first ? {first: true, referral: first} : null,
    last && !(first && sameReferral(first, last)) ? {first: false, referral: last} : null
  ].filter(Boolean);
};
